import { autoinject, bindable } from 'aurelia-framework';
import { PubSub } from 'lib/event/PubSub';
import { AsyncErrorHandler, DialogHandler } from 'lib/ui';
import { MooringProductionTaskType, PluckingListDto } from 'models/mooring';
import { ToastService } from 'services';
import { MooringProductionOrderService } from 'services/mooring';
import { HourListDialog } from '../hours/hour-list-dialog';

@autoinject
export class BridlesContainer {
  protected pluckList: PluckingListDto[] = [];

  @bindable
  productionOrderId: number;

  constructor(
    private productionOrderService: MooringProductionOrderService,
    private toast: ToastService,
    private pubsub: PubSub,
    private dialog: DialogHandler
  ) {}

  protected attached() {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }

    void this.getBridlesPluckingList();
  }

  @AsyncErrorHandler
  async getBridlesPluckingList() {
    const { data } = await this.productionOrderService.getBridlesPluckingList(this.productionOrderId);
    this.pluckList = data;
  }

  @AsyncErrorHandler
  protected async onSave({ canNavigateOnSave, entries }: { canNavigateOnSave: boolean; entries: PluckingListDto[] }) {
    if (!this.productionOrderId || this.productionOrderId <= 0) {
      throw new Error('productionOrderId is required');
    }

    const dto = entries.map((line) => ({
      ArticleId: line.ArticleId,
      Certificates: line.Certificates.map((certificate) => ({
        CertificateId: certificate.CertificateId,
        Quantity: certificate.Quantity,
        ActualBatchNo: certificate.ActualBatchNo,
      })),
    }));

    await this.productionOrderService.setBridlesPluckingList(this.productionOrderId, dto);
    this.toast.showUpdated();

    if (canNavigateOnSave) {
      this.pubsub.publish('tabs:change-guard-ok', null);
    }

    await this.getBridlesPluckingList();
  }

  protected async openHoursDialog() {
    await this.dialog.open(HourListDialog, {
      productionOrderId: this.productionOrderId,
      taskOptions: [MooringProductionTaskType.BridlePicking, MooringProductionTaskType.BridleAssembly],
    });
  }
}
